import { render } from "./IndexHomePage.vue?vue&type=template&id=959fe262"
import script from "./IndexHomePage.vue?vue&type=script&lang=js"
export * from "./IndexHomePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__